import { SetBasicPrio, SetKanoPrio, SetStorymapFrameworkType } from '../../../store/actions';

import * as storymapStoreModule from '../../../store';
import { uuid } from '@/_core/utils/uuid';
import { BoardUserActivityType } from '@/api/workspaceSettings/queries';
import { BasicPrioValue, BusinessValue, Effort, KanoPrioValue, MoscowPrioValue, StorymapPrioFrameworkType } from '../../queries';
import { ChangeCardBusinessValue, ChangeCardEffort, ChangeCardPrio, ChangeStorymapPrioFramework } from '..';
import { SetBusinessValue } from '../../../store/actions/prio/setBusinessValue';
import { SetEffort } from '../../../store/actions/prio/setEffort';
import { SetMoscowPrio } from '../../../store/actions/prio/setMoscowPrio';

export const createSetBasicPrioCommand = async (action: SetBasicPrio) => {
    const store = storymapStoreModule.useStorymapStore();
    const state = store.state;

    const card = state.subtasks.find((x) => x.id === action.cardId);

    const cmd = new ChangeCardPrio(state.id, action.cardId, action.priority, StorymapPrioFrameworkType.Basic);
    const activityId = await uuid.create();

    const activity = {
        CardId: card.id,
        CardName: card.title,
        Datetime: new Date().toJSON(),
        CardDescription: '',
        EstimationUnit: '',
        OriginalContent: BasicPrioValue[card.basicPrioValue] ?? 'not set',
        Content: BasicPrioValue[action.priority] ?? 'not set',
        Id: activityId,
        StorymapId: state.id,
        WorkspaceId: initAppData.currentWs.workspaceId,
        Type: BoardUserActivityType.PriorityChanged,
        UserId: initAppData.currentUser.currentUserShortId,
        Username: initAppData.currentUser.currentUserFullName,
    };

    cmd.BoardActivity = activity;

    return cmd;
};

export const createSetKanoPrioCommand = async (action: SetKanoPrio) => {
    const store = storymapStoreModule.useStorymapStore();
    const state = store.state;

    const card = state.subtasks.find((x) => x.id === action.cardId);

    const cmd = new ChangeCardPrio(state.id, action.cardId, action.priority, StorymapPrioFrameworkType.Kano);
    const activityId = await uuid.create();

    const activity = {
        CardId: card.id,
        CardName: card.title,
        Datetime: new Date().toJSON(),
        CardDescription: '',
        EstimationUnit: '',
        OriginalContent: KanoPrioValue[card.kanoPrioValue] ?? 'not set',
        Content: KanoPrioValue[action.priority] ?? 'not set',
        Id: activityId,
        StorymapId: state.id,
        WorkspaceId: initAppData.currentWs.workspaceId,
        Type: BoardUserActivityType.PriorityChanged,
        UserId: initAppData.currentUser.currentUserShortId,
        Username: initAppData.currentUser.currentUserFullName,
    };

    cmd.BoardActivity = activity;

    return cmd;
};

export const createSetMoscowPrioCommand = async (action: SetMoscowPrio) => {
    const store = storymapStoreModule.useStorymapStore();
    const state = store.state;

    const card = state.subtasks.find((x) => x.id === action.cardId);

    const cmd = new ChangeCardPrio(state.id, action.cardId, action.priority, StorymapPrioFrameworkType.Moscow);
    const activityId = await uuid.create();

    const activity = {
        CardId: card.id,
        CardName: card.title,
        Datetime: new Date().toJSON(),
        CardDescription: '',
        EstimationUnit: '',
        OriginalContent: MoscowPrioValue[card.moscowPrioValue] ?? 'not set',
        Content: MoscowPrioValue[action.priority] ?? 'not set',
        Id: activityId,
        StorymapId: state.id,
        WorkspaceId: initAppData.currentWs.workspaceId,
        Type: BoardUserActivityType.PriorityChanged,
        UserId: initAppData.currentUser.currentUserShortId,
        Username: initAppData.currentUser.currentUserFullName,
    };

    cmd.BoardActivity = activity;

    return cmd;
};

export const createSetBusinessValueCommand = async (action: SetBusinessValue) => {
    const store = storymapStoreModule.useStorymapStore();
    const state = store.state;

    const card = state.subtasks.find((x) => x.id === action.cardId);

    const cmd = new ChangeCardBusinessValue(state.id, action.cardId, action.businessValue);
    const activityId = await uuid.create();

    const activity = {
        CardId: card.id,
        CardName: card.title,
        Datetime: new Date().toJSON(),
        CardDescription: '',
        EstimationUnit: '',
        OriginalContent: BusinessValue[card.businessValue] ?? 'not set',
        Content: BusinessValue[action.businessValue] ?? 'not set',
        Id: activityId,
        StorymapId: state.id,
        WorkspaceId: initAppData.currentWs.workspaceId,
        Type: BoardUserActivityType.BusinessValueChanged,
        UserId: initAppData.currentUser.currentUserShortId,
        Username: initAppData.currentUser.currentUserFullName,
    };

    cmd.BoardActivity = activity;

    return cmd;
};

export const createSetEffortCommand = async (action: SetEffort) => {
    const store = storymapStoreModule.useStorymapStore();
    const state = store.state;

    const card = state.subtasks.find((x) => x.id === action.cardId);

    const cmd = new ChangeCardEffort(state.id, action.cardId, action.effort);
    const activityId = await uuid.create();

    const activity = {
        CardId: card.id,
        CardName: card.title,
        Datetime: new Date().toJSON(),
        CardDescription: '',
        EstimationUnit: '',
        OriginalContent: Effort[card.effort] ?? 'not set',
        Content: Effort[action.effort] ?? 'not set',
        Id: activityId,
        StorymapId: state.id,
        WorkspaceId: initAppData.currentWs.workspaceId,
        Type: BoardUserActivityType.EffortChanged,
        UserId: initAppData.currentUser.currentUserShortId,
        Username: initAppData.currentUser.currentUserFullName,
    };

    cmd.BoardActivity = activity;

    return cmd;
};

export const createChangeStorymapPrioFrameworkCommand = async (action: SetStorymapFrameworkType) => {
    const store = storymapStoreModule.useStorymapStore();
    const state = store.state;

    const cmd = new ChangeStorymapPrioFramework(state.id, action.type);
    const activityId = await uuid.create();

    const activity = {
        Datetime: new Date().toJSON(),
        OriginalContent: state.prioFrameworkType,
        Content: action.type,
        Id: activityId,
        StorymapId: state.id,
        WorkspaceId: initAppData.currentWs.workspaceId,
        Type: BoardUserActivityType.PrioFrameworkChanged,
        UserId: initAppData.currentUser.currentUserShortId,
        Username: initAppData.currentUser.currentUserFullName,
    };

    cmd.BoardActivity = activity;

    return cmd;
};
